import { render, staticRenderFns } from "./ConversationsPage.vue?vue&type=template&id=dfb39fbe&"
import script from "./ConversationsPage.vue?vue&type=script&lang=ts&"
export * from "./ConversationsPage.vue?vue&type=script&lang=ts&"
import style0 from "./ConversationsPage.vue?vue&type=style&index=0&id=dfb39fbe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports